import { Helmet } from 'react-helmet-async';

export default function EventSchema({ activity, tour }) {
  // Normalize tour into activity shape if tour was passed
  const data = tour ? {
    id: tour.id,
    date: tour.date,
    name: tour.description,
    description: tour.venueDescription,
    type: 'tourevent',
    host: tour.venue,
    hostlink: tour.venueLink,
    link: `https://sri-kaza.com/book-tour/${tour.id}`,
    city: tour.city,
    address: tour.address,
  } : activity;

  if (!data) return null;

  const isoDate = new Date(data.date).toISOString();

  // Schema type
  const schemaType = data.type === 'podcast' ? 'PodcastEpisode' : 'Event';

  // URL
  const eventUrl = data.type === 'tourevent'
    ? data.link
    : (data.link && data.link !== '...')
      ? data.link
      : `https://sri-kaza.com/media/${data.id}`;

  // Attendance mode
  const attendanceMode = data.type === 'tourevent'
    ? 'https://schema.org/OfflineEventAttendanceMode'
    : 'https://schema.org/OnlineEventAttendanceMode';

  // Location — only for in-person tour events
  const location = data.type === 'tourevent' ? {
    "@type": "Place",
    "name": data.host,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": data.address,
      "addressLocality": data.city,
    }
  } : undefined;

  const schema = {
    "@context": "https://schema.org",
    "@type": schemaType,
    "name": data.name,
    "description": data.description,
    "startDate": isoDate,
    "endDate": isoDate,
    "eventStatus": "https://schema.org/EventScheduled",
    "eventAttendanceMode": attendanceMode,
    "url": eventUrl,
    ...(location && { "location": location }),
    "organizer": {
      "@type": "Organization",
      "name": data.host,
      "url": data.hostlink,
    },
    "performer": {
      "@type": "Person",
      "@id": "https://sri-kaza.com/#person",
      "name": "Sri Kaza",
      "url": "https://sri-kaza.com"
    },
    "about": {
      "@type": "Book",
      "name": "Unconvention: A Small Business Strategy Guide",
      "@id": "https://sri-kaza.com/book"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}